import { createProgramUnitInstance, type ProgramUnitInstance } from '@/modules/api';

import { MEMBER_CONTACT_PROGRAM_UNIT_UUID } from '../constants/programUnit';

/**
 * Creates/starts the Member Contact program-unit instance (ME-1256). This is the
 * same mechanism the dynamic screener uses; submitting the instance's responses
 * is what writes to the profile and checks off the MWL checklist (backend side
 * effects) — the answers are layered on in the form step.
 *
 * Throws if the backend returns no instance so the caller can surface an error
 * and keep the user on the screen.
 */
export async function createMemberContactInstance(): Promise<ProgramUnitInstance> {
  const instance = await createProgramUnitInstance(MEMBER_CONTACT_PROGRAM_UNIT_UUID);
  if (!instance) {
    throw new Error('Member Contact program unit instance was not created.');
  }
  return instance;
}
